/**
 * ⚠️  AUTO-GENERATED — DO NOT EDIT MANUALLY ⚠️
 *
 * Generated by: scripts/preload-query-batch-classifier/index.mjs
 *
 * Per-region SSR preloaded GraphQL query classification using bitmap encoding.
 * Q contains all query names (sorted, with index comments). R maps each SSR
 * region to a hex bitmap where bit i = 1 means Q[i] is fast (batchable).
 *
 * Per-region classification summary (fast/slow/excluded counts) is
 * embedded in the PR description.
 *
 * Thresholds (prod): p90 ≤ 300ms | p95 ≤ 500ms | p99 ≤ 1000ms | min n=100
 * Thresholds (staging): p90 ≤ 600ms | p95 ≤ 1000ms | p99 ≤ 2000ms | min n=100
 * Lookback: last 3 business days
 * Generated: 2026-05-26T03:16:13.252Z
 */

// prettier-ignore
export const Q: readonly string[] = [
	'ActiveCommentsQuery', // 0
	'ApprovalsContextApprovalsDataQuery', // 1
	'ArchivedPageBannerV2ArchivedPageBannerContainerQuery', // 2
	'ArchivedPageBannerV2ArchivedPageBannerQuery', // 3
	'BlogTreeRootComponentQuery', // 4
	'CollabDraftQuery', // 5
	'CollabDraftWithRelevanceQuery', // 6
	'ContentBlogUnifiedQuery', // 7
	'ContentHeaderPresenceContentSettingsQuery', // 8
	'ContentHeaderUnifiedQuery', // 9
	'ContentPrerequisitesQuery', // 10
	'ContentRedirectQuery', // 11
	'ContentTypesHeaderQuery', // 12
	'ContentUnifiedQuery', // 13
	'ContentUnifiedWithSpaceKeyQuery', // 14
	'CookieConsentPreferences', // 15
	'CoverPictureQuery', // 16
	'CustomHeaderFooterQuery', // 17
	'DatabaseContainerQuery', // 18
	'EditContentButtonQuery', // 19
	'EditorContentStateQuery', // 20
	'EditorPreferencesQuery', // 21
	'EmojiTitleQuery', // 22
	'EndOfPageRecommendationQuery', // 23
	'FetchPreFilteredForgeAppsQuery_confluence_contentBylineItem', // 24
	'FetchPreFilteredForgeAppsQuery_confluence_spacePage', // 25
	'FetchPreFilteredForgeAppsQuery_xen_macro', // 26
	'FollowingFeedWithSortByStorageSnippetsQuery', // 27
	'FooterCreateButtonsQuery', // 28
	'ForgeExtensionList', // 29
	'GlobalNavigationComponentQuery', // 30
	'GrantAccessDialogLoaderQuery', // 31
	'HomeRecentWorkQuery', // 32
	'InlineCommentsFocusedInlineCommentQuery', // 33
	'LegacyMacroRendererQueryBodyQuery', // 34
	'LivePagesByLineLastUpdatedQuery', // 35
	'LocalStorageQuery', // 36
	'NativeCollabQuery', // 37
	'NotFoundContainerQuery', // 38
	'NotificationsButtonQuery', // 39
	'ObjectCommentContainerPreloadObjectCommentsQuery', // 40
	'PageRestrictionsContextQuery', // 41
	'PageTreeQuery', // 42
	'PageTreeQueryWithSpaceKeyQuery', // 43
	'PermissionCheckAddCommentQuery', // 44
	'PersistentInviteEligibleQuery', // 45
	'PersonalizedTemplatesV2AllTemplatesQuery', // 46
	'PopularFeedWithTimeGranularityStorageSnippetsQuery', // 47
	'PopularFeedWithTimeGranularityStorageSnippetsV2Query', // 48
	'Preferences', // 49
	'PremiumTrialEotQuery', // 50
	'ReactionsContentQuery', // 51
	'RendererContentStateQuery', // 52
	'RestrictedPageWithCanViewQuery', // 53
	'ScreenQuery', // 54
	'SiteInformationQuery', // 55
	'SmartCreateFeedbackBannerQuery', // 56
	'SmartCreatePageEditorDataWrapperComponentQuery', // 57
	'SpaceNavigationQuery', // 58
	'SpaceOverviewIdQuery', // 59
	'SpaceOverviewQuery', // 60
	'SpaceQuery', // 61
	'SpaceRestrictionCheckQuery', // 62
	'ThemeQuery', // 63
	'TopNavigationQuery', // 64
	'UserSettingsQuery', // 65
	'ViewSpaceExternalCollaboratorsDialogQuery', // 66
	'WebItemLocationQuery_page.metadata.banner', // 67
	'WebItemLocationQuery_system.content.byline', // 68
	'WebItemLocationQuery_system.header_left', // 69
	'WebItemLocationQuery_system.header_left_system.user', // 70
	'WebPanelLocationQuery_atl.footer', // 71
	'WebPanelLocationQuery_atl.general', // 72
	'WebPanelLocationQuery_atl.general_atl.footer', // 73
	'WebPanelLocationQuery_atl.page.content.footer.actions', // 74
	'WebStorageCategories', // 75
	'WelcomeMessagesQuery', // 76
	'WhiteboardUnifiedQuery', // 77
	'bifrost-ssr/prepare/preloadQuery/editor/nodeDataProvidersData/fetch:AdfDocQuery', // 78
	'bifrost-ssr/prepare/preloadQuery/renderer/syncedBlocksData/fetch:SyncBlockReferences', // 79
	'contentAppearanceQuery', // 80
	'contentSmartLinksORS', // 81
	'fetchMentionsProviderDataQuery', // 82
	'graphqlHelpersDSPIsActionEnabledForContentQuery', // 83
	'graphqlHelpersFetchMediaTokenQuery', // 84
	'multiMacroQueryWithAppKeyQuery', // 85
	'onboardingStateGetOnboardingStateQuery', // 86
	'onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8', // 87
	'onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered', // 88
	'onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal', // 89
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2', // 90
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6', // 91
	'onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages_2', // 92
	'onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12', // 93
	'onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt', // 94
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18', // 95
	'onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_66', // 96
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin', // 97
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10', // 98
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5', // 99
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6', // 100
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp', // 101
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_151', // 102
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_152', // 103
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_154', // 104
	'pageButtons', // 105
	'preloadAutohighlightsQuery', // 106
	'preloadContentSmartLinksQuery', // 107
	'preloadCreateSpaceQuery', // 108
	'preloadEditButtonWithSpaceKeyQuery', // 109
	'preloadEditorNodeDataProvidersDataQuery', // 110
	'preloadForgeApps_FetchPreFilteredForgeAppsQuery', // 111
	'preloadLegacyBridgeQuery', // 112
	'preloadOperationsQuery', // 113
	'preloadPageStatusQueryDataQuery', // 114
	'preloadPersonalSpaceDetailsQuery', // 115
	'preloadShareAndRestrictButtonQuerySpaceOverviewQuery', // 116
	'preloadSpaceBlogCountQuery', // 117
	'preloadTemplatesCollectionEligibleQuery', // 118
	'requireSuperBatchFrontendResourceRenderQuery', // 119
	'rightPanel', // 120
	'searchResults', // 121
	'shortcutsSmartLinksQuery', // 122
	'sidenavSmartLinksORS', // 123
	'ssr-app/prepare/preloadQuery/editor/nodeDataProvidersData/fetch:AdfDocQuery', // 124
	'useAnalyticsByLineQuery', // 125
	'useAudioContentQuery', // 126
	'useConfluenceStandardToPremiumExperimentQuery', // 127
	'useContentClassificationContentDataClassificationQuery', // 128
	'useEditorContentModeValueQuery', // 129
	'useEmojiEverSetPropertyQuery', // 130
	'useFabricEligibilityMigrationQuery', // 131
	'useFeatureDiscoveryFeatureDiscoveryQuery', // 132
	'useFeedTypeSelectorRefreshQuery', // 133
	'useFollowingFeedWithSortByStorageFeedContentQuery', // 134
	'useGetCurrentStorageUsageQuery', // 135
	'useGetTeamAndSubanchorGetPersonalSpaceKeyQuery', // 136
	'useGetTeamAndSubanchorGetSubanchorsAGGQuery', // 137
	'useHomeWidgetStateQuery', // 138
	'useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery', // 139
	'useIsLoomEntryPointsEnabledQuery', // 140
	'useIsUserViewingSpaceAsAnonQuery', // 141
	'useLicensedProductsQueryForGlobalAppShortcutsQuery', // 142
	'useLoomTenantProvisionStatusQuery', // 143
	'usePopularFeedWithTimeGranularityStorageQuery', // 144
	'usePreloadCommentButtonQuery', // 145
	'useReadTimeQuery', // 146
	'useRegisterAdminAnnouncementBannerQuery', // 147
	'useShareAndRestrictButtonDataQuery', // 148
	'useShortcutsSpaceNavigationQuery', // 149
	'useSpaceBaseQueryBaseQuery', // 150
	'useSpaceDetailQuery', // 151
	'useSpaceEnabledContentTypesQuery', // 152
	'useSpaceViewsDataSpaceRootQuery', // 153
	'useSpaceViewsOptionsPersistenceQuery', // 154
	'useSpacesDataAnonymousSpacesQuery', // 155
	'useSpacesDataMyVisitedSpacesQuery', // 156
	'useSpacesDataStarredSpacesQuery', // 157
	'useTitleContentPropertiesForEditorQuery', // 158
	'useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery', // 159
	'useTitleContentPropertiesForPublishedPageQuery', // 160
	'useUserByLicensedProductsQuery', // 161
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	'prod-apne': '9dff7b77fa5ff6ffbf6dfdfb7fffffd13ff7fee703', /* 132 fast, 17 slow, 7 excl */
	'prod-apne2': '35ff7b77fa5ff6fdbf6dfdfb7fff7fd1bff7fee703', /* 130 fast, 16 slow, 11 excl */
	'prod-apse': 'bdff7bf7fb5ffeffbf7dfdfb7ffffff3bff7feef03', /* 141 fast, 12 slow, 40 excl */
	'prod-apse2': 'bdff7bf7fa5ffeffbf7dfdfb7ffffff3bff7feff03', /* 141 fast, 12 slow, 14 excl */
	'prod-apsouth': '95ff7b77fa5ff6ffbf7dfdfb7fff7ff3bff7fee703', /* 134 fast, 14 slow, 79 excl */
	'prod-cacentral': 'bdff7b77fb7ffeffbf7dfdfb7fff7ff3bffffef703', /* 141 fast, 8 slow, 11 excl */
	'prod-east': '9dff7ff7fb7ffeffbf7dfdfbfffffff7bffffeff03', /* 146 fast, 11 slow, 58 excl */
	'prod-eucentral': '9fff7ff7fb5ffeffbf6dfdfb7fffffd7bff7feef03', /* 141 fast, 15 slow, 53 excl */
	'prod-eucentral2': 'a5df7b37f857fefd3f6ddd7b7fff5fd0bff7fee701', /* 121 fast, 23 slow, 13 excl */
	'prod-euwest': 'bfff7ff7fb7ffeffbf7dfdfb7fffffd7bffffeff03', /* 146 fast, 11 slow, 110 excl */
	'prod-euwest2': 'bdff7bf7fb7ffeffbf7dfdfb7fff7ff3bffffef703', /* 142 fast, 8 slow, 12 excl */
	'prod-west2': '9dff7bf7fe7ffeffbf7dfdfb7ffffff3bffffeef03', /* 142 fast, 11 slow, 34 excl */
	'stg-east': '76f3fb77a97ffbddff57ffff3efe7fefbffffff703', /* 135 fast, 5 slow, 59 excl */
};
